import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Carousal from "../components/layouts/carousal";
import Navbar from "../components/layouts/navbar";

import 'bootstrap/dist/css/bootstrap.min.css';



function Services() {

    return (
        <>
            <Navbar />
            <Box>
                <Typography variant="h1" sx={{ padding: "10px" }}> Our Services</Typography>

            </Box>

            <Box>
                
            </Box>



        </>
    )
}


export default Services;